const AccountTypeEnum = Object.freeze({
    PLATFORM: 'PLATFORM',
    FUND: 'FUND',
    ISA: 'ISA',
    ISAFUND: 'ISAFUND'
});

export default AccountTypeEnum;
